import React from 'react';
import { observer } from "mobx-react";
import { TitanJackpotAmountBox } from './boxes/titan-jackpot-amount-container.box'
import { useServices } from '../../react-hooks/use-services.hook';
import {TitanJackpotWidgetController} from "./titan-jackpot-widget-controller";

export const TitanJackpotAmountComponent: React.FC<{widgetController: TitanJackpotWidgetController;}> = observer((props) => {
    const services = useServices();

    const amount = props.widgetController.jackpot?.widgetCurrentAnimatedAmountInCents ?? 0;

    return (
        <TitanJackpotAmountBox>
            {services.currency.formatMoney(amount)}
        </TitanJackpotAmountBox>
    )
});